import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export const useIconStyles = makeStyles()(({ shape, spacing }: Theme) => ({
  markerPadding: {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: spacing(1),
    paddingRight: spacing(1),
  },
  image: {
    borderRadius: shape.borderRadius,
    height: 52,
    width: 52,
    margin: spacing(0, 1),
  },
}));
